import React from 'react';
export default function StopCircleIcon() {
  return React.createElement("svg", {
    width: '44',
    height: '44',
    viewBox: '0 0 44 44',
    fill: 'none',
    xmlns: 'http://www.w3.org/2000/svg'
  }, React.createElement("rect", {
    width: '44',
    height: '44',
    rx: '22',
    fill: 'url(#paint0_linear_90_4160)'
  }), React.createElement("rect", {
    width: '44',
    height: '44',
    rx: '22',
    fill: 'url(#paint1_radial_90_4160)',
    fillOpacity: '0.7'
  }), React.createElement("rect", {
    width: '44',
    height: '44',
    rx: '22',
    fill: 'url(#paint2_radial_90_4160)',
    fillOpacity: '0.3'
  }), React.createElement("path", {
    d: 'M19 26H25C25.2833 26 25.5208 25.9042 25.7125 25.7125C25.9042 25.5208 26 25.2833 26 25V19C26 18.7167 25.9042 18.4792 25.7125 18.2875C25.5208 18.0958 25.2833 18 25 18H19C18.7167 18 18.4792 18.0958 18.2875 18.2875C18.0958 18.4792 18 18.7167 18 19V25C18 25.2833 18.0958 25.5208 18.2875 25.7125C18.4792 25.9042 18.7167 26 19 26ZM22 32C20.6167 32 19.3167 31.7375 18.1 31.2125C16.8833 30.6875 15.825 29.975 14.925 29.075C14.025 28.175 13.3125 27.1167 12.7875 25.9C12.2625 24.6833 12 23.3833 12 22C12 20.6167 12.2625 19.3167 12.7875 18.1C13.3125 16.8833 14.025 15.825 14.925 14.925C15.825 14.025 16.8833 13.3125 18.1 12.7875C19.3167 12.2625 20.6167 12 22 12C23.3833 12 24.6833 12.2625 25.9 12.7875C27.1167 13.3125 28.175 14.025 29.075 14.925C29.975 15.825 30.6875 16.8833 31.2125 18.1C31.7375 19.3167 32 20.6167 32 22C32 23.3833 31.7375 24.6833 31.2125 25.9C30.6875 27.1167 29.975 28.175 29.075 29.075C28.175 29.975 27.1167 30.6875 25.9 31.2125C24.6833 31.7375 23.3833 32 22 32ZM22 30C24.2333 30 26.125 29.225 27.675 27.675C29.225 26.125 30 24.2333 30 22C30 19.7667 29.225 17.875 27.675 16.325C26.125 14.775 24.2333 14 22 14C19.7667 14 17.875 14.775 16.325 16.325C14.775 17.875 14 19.7667 14 22C14 24.2333 14.775 26.125 16.325 27.675C17.875 29.225 19.7667 30 22 30Z',
    fill: 'white'
  }), React.createElement("defs", null, React.createElement("linearGradient", {
    id: 'paint0_linear_90_4160',
    x1: '5.53642',
    y1: '5.58586',
    x2: '38.0021',
    y2: '35.6535',
    gradientUnits: 'userSpaceOnUse'
  }, React.createElement("stop", {
    stopColor: '#7701BB'
  }), React.createElement("stop", {
    offset: '0.0745527',
    stopColor: '#7601BB'
  }), React.createElement("stop", {
    offset: '0.146751',
    stopColor: '#7503BC'
  }), React.createElement("stop", {
    offset: '0.216879',
    stopColor: '#7205BD'
  }), React.createElement("stop", {
    offset: '0.285219',
    stopColor: '#6E09BF'
  }), React.createElement("stop", {
    offset: '0.352055',
    stopColor: '#690DC1'
  }), React.createElement("stop", {
    offset: '0.41767',
    stopColor: '#6312C4'
  }), React.createElement("stop", {
    offset: '0.482348',
    stopColor: '#5C18C7'
  }), React.createElement("stop", {
    offset: '0.54637',
    stopColor: '#541FCA'
  }), React.createElement("stop", {
    offset: '0.610022',
    stopColor: '#4C27CE'
  }), React.createElement("stop", {
    offset: '0.673586',
    stopColor: '#422FD2'
  }), React.createElement("stop", {
    offset: '0.737345',
    stopColor: '#3738D7'
  }), React.createElement("stop", {
    offset: '0.801582',
    stopColor: '#2C42DC'
  }), React.createElement("stop", {
    offset: '0.866582',
    stopColor: '#204DE1'
  }), React.createElement("stop", {
    offset: '0.932627',
    stopColor: '#1358E7'
  }), React.createElement("stop", {
    offset: '1',
    stopColor: '#0564ED'
  })), React.createElement("radialGradient", {
    id: 'paint1_radial_90_4160',
    cx: '0',
    cy: '0',
    r: '1',
    gradientUnits: 'userSpaceOnUse',
    gradientTransform: 'translate(6.4106 2.35194) rotate(74.8737) scale(20.0999 49.1709)'
  }, React.createElement("stop", {
    stopColor: '#F5EBFA'
  }), React.createElement("stop", {
    offset: '0.161458',
    stopColor: '#EEDEF6',
    stopOpacity: '0.864583'
  }), React.createElement("stop", {
    offset: '0.333333',
    stopColor: '#E8D2F3',
    stopOpacity: '0.735701'
  }), React.createElement("stop", {
    offset: '0.661458',
    stopColor: '#D1A8E8',
    stopOpacity: '0.290563'
  }), React.createElement("stop", {
    offset: '0.822917',
    stopColor: '#C999E4',
    stopOpacity: '0.137944'
  }), React.createElement("stop", {
    offset: '1',
    stopColor: '#C28CE0',
    stopOpacity: '0'
  })), React.createElement("radialGradient", {
    id: 'paint2_radial_90_4160',
    cx: '0',
    cy: '0',
    r: '1',
    gradientUnits: 'userSpaceOnUse',
    gradientTransform: 'translate(35.8411 39.395) rotate(-120.035) scale(12.2254 27.3643)'
  }, React.createElement("stop", {
    stopColor: '#E8F2FF'
  }), React.createElement("stop", {
    offset: '0.0001',
    stopColor: '#E8F2FF'
  }), React.createElement("stop", {
    offset: '1',
    stopColor: '#99C3F9',
    stopOpacity: '0'
  }))));
}